// Tailwind safelist: bg-green-600 hover:bg-green-500 focus-visible:outline-green-600
export default function TrackingIdModalDataTable({ data, onReceiveUnitsClick }) {
    return (
        <div>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-base font-semibold text-gray-900">Tracking Data</h1>
                        <p className="mt-2 text-sm text-gray-700">
                            Details of tracked items including item name, FNSKU, order ID, and quantity.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-8 flow-root overflow-hidden">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <table className="w-full text-left border-separate border-spacing-0 border border-gray-200">
                        <thead className="bg-gray-100">
                        <tr>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Order ID</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">FNSKU</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Item SKU</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Item Name</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Expected Quantity</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Received Qty</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Status</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Disposition</th>
                            <th className="px-4 py-2 text-sm font-semibold text-gray-900 border-b">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((item, index) => {
                            // Determine badge color based on status
                            const getStatusBadgeClass = (status) => {
                                if (status === 'Received') {
                                    return 'bg-green-100 text-green-800';
                                } else if (status === 'Not Received') {
                                    return 'bg-red-100 text-red-800';
                                } else if (status === 'Partially Received') {
                                    return 'bg-yellow-100 text-yellow-800';
                                }
                                return 'bg-gray-100 text-gray-800';
                            };

                            return (
                                <tr key={item.removal_shipment_detail_id ?? index} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border-b text-sm text-gray-700">{item.order_id}</td>
                                    <td className="px-4 py-2 border-b text-sm text-gray-700 font-mono">{item.fnsku}</td>
                                    <td className="px-4 py-2 border-b text-sm text-gray-700 font-mono">{item.item_code || '—'}</td>
                                    <td className="px-4 py-2 border-b text-sm text-gray-700">{item.item_name}</td>
                                    <td className="px-4 py-2 border-b text-sm text-gray-700">{item.shipped_quantity}</td>
                                    <td className="px-4 py-2 border-b text-sm text-gray-700">{item.dispositioned || 0}</td>
                                    <td className="px-4 py-2 border-b text-sm">
                                        <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${getStatusBadgeClass(item.status)}`}>
                                            {item.status || 'Not Received'}
                                        </span>
                                    </td>
                                    <td className="px-4 py-2 border-b text-sm text-gray-700">{item.disposition}</td>
                                    <td className="px-4 py-2 border-b text-sm">
                                        <button
                                            type="button"
                                            onClick={() => onReceiveUnitsClick(item)}
                                            className={`rounded px-2 py-1 text-xs font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                                item.status === 'Received'
                                                    ? 'bg-green-600 hover:bg-green-500 focus-visible:outline-green-600'
                                                    : 'bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'
                                            }`}
                                        >
                                            {item.status === 'Received' ? 'Edit' : 'Receive Units'}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
